import { FactoringCompany } from '../../../providers/User/User.model';
import { twApi } from '../api';
import { InternalFactoringPayload } from './internalFactoring.model';

const internalFactoringApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getInternalFactoringCompany: builder.query<FactoringCompany, { divisionId: string }>({
      query: ({ divisionId }) => ({
        url: `/settings/factoring-company/${divisionId}`,
        method: 'GET'
      }),
      transformResponse: (response: { data: FactoringCompany }) => response.data,
      providesTags: () => [{ type: 'InternalFactoring', id: 'INTERNAL_FACTORING_COMPANY' }]
    }),
    createInternalFactoring: builder.mutation<
      FactoringCompany,
      { divisionId: string; data: InternalFactoringPayload }
    >({
      query: ({ divisionId, data }) => ({
        url: `/settings/factoring-company/${divisionId}`,
        method: 'POST',
        body: data
      }),
      transformResponse: (response: { data: FactoringCompany }) => {
        return response.data;
      }
    }),
    deleteInternalFactoringCompany: builder.mutation<FactoringCompany, string>({
      query: (divisionId) => ({
        url: `/settings/factoring-company/${divisionId}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'InternalFactoring', id },
        { type: 'InternalFactoring', id: 'INTERNAL_FACTORING_COMPANY' }
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useGetInternalFactoringCompanyQuery,
  useCreateInternalFactoringMutation,
  useDeleteInternalFactoringCompanyMutation
} = internalFactoringApi;
